import { AppConfig } from './config.model';
import { InjectionToken } from '@angular/core';

export const MAIN_APP_CONFIG = new InjectionToken<AppConfig>('MAIN_APP_CONFIG', {
  providedIn: 'root',
  factory: () => ({
    baseTitle: '',
    layout: 'dense',
    scheme: 'auto',
    screens: {
      mobile: '320px',
      sm: '600px',
      md: '960px',
      lg: '1280px',
      xl: '1440px',
      xxl: '1600px',
    },
    theme: 'theme-default',
    themes: [
      {
        id: 'theme-default',
        name: 'Default',
      },
      {
        id: 'theme-home',
        name: 'Home',
      },
    ],
  }),
});
